import { useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';

import {
  isConversationRoute,
  clearMetadataSearchSession,
} from '../utils/conversationMetadataSearchPersistence';

const clearUnlessConversationRoute = (pathname: string): void => {
  if (!isConversationRoute(pathname)) {
    clearMetadataSearchSession();
  }
};

export const useMetadataSearchLeave = (): void => {
  const history = useHistory();
  const pathnameRef = useRef(history.location.pathname);

  useEffect(() => {
    return history.listen(location => {
      pathnameRef.current = location.pathname;
    });
  }, [history]);

  useEffect(() => {
    return () => {
      clearUnlessConversationRoute(pathnameRef.current);
    };
  }, []);
};
